export default class ShowMoreClass {
    private showButton: HTMLButtonElement[] | null;

    constructor() {
        this.showButton = [...document.querySelectorAll<HTMLButtonElement>(".show-more-text-btn")];
        this.init();
    }

    public init = async (): Promise<void> => {
        if (!this.showButton) return;

        this.showButton?.forEach((button) => {
            button.addEventListener("click", this.switchTextVisibleLength);
        });
    };

    private switchTextVisibleLength = (e): void => {
        e.preventDefault();
        const currentText = e.currentTarget.parentNode.querySelector(".short-text") as HTMLElement;
        const buttonText = e.currentTarget.textContent;
        const moreText = window.translatedString.more;
        const lessText = window.translatedString.less;

        currentText.classList.toggle("short-text--active");

        e.currentTarget.parentNode.classList.toggle("show-more");

        buttonText.toLowerCase() === moreText.toLowerCase() ? (e.currentTarget.textContent = lessText) : (e.currentTarget.textContent = moreText);
    };
}
